import React from 'react'
import gql from 'graphql-tag'
import RouteAdminFeaturesGroupUsersQuery from 'routes/admin/features/group/users.query'
import { Mutation } from 'react-apollo'
import { prop } from 'utils/fp'

const REMOVE_USERS_FROM_GROUP = gql`
  mutation RemoveUsersFromFeatureGroupMutation(
    $input: RemoveUsersFromGroupInput!
  ) {
    removeUsersFromGroup(input: $input) {
      group {
        id
        users(first: 100) {
          edges {
            node {
              id
              email
              firstName
              lastName
            }
          }
        }
      }

      users {
        id
        features
      }
    }
  }
`

const RemoveUsersFromFeatureGroupMutation = ({ children, group }) => (
  <Mutation mutation={REMOVE_USERS_FROM_GROUP}>
    {(mutation, props) =>
      children({
        ...props,
        removeUsersFromGroup: users =>
          mutation({
            variables: {
              input: {
                groupId: group.id,
                userIds: users.map(prop('id'))
              }
            },
            update: cache => {
              const data = cache.readQuery({
                variables: { groupId: group.id },
                query: RouteAdminFeaturesGroupUsersQuery
              })

              const userEdges = data.group.users.edges.filter(
                ({ node }) => !users.some(user => user.id === node.id)
              )

              cache.writeQuery({
                variables: { groupId: group.id },
                query: RouteAdminFeaturesGroupUsersQuery,
                data: {
                  group: {
                    ...data.group,
                    users: {
                      ...data.group.users,
                      edges: userEdges
                    }
                  }
                }
              })
            }
          })
      })
    }
  </Mutation>
)

export default RemoveUsersFromFeatureGroupMutation



// WEBPACK FOOTER //
// ./src/components/mutations/RemoveUsersFromFeatureGroup.js